<template>
	<div class="profile-ud-list sip-kv-grid" v-if="customFields && customFields.length">
        <template v-for="field in customFields">
            <view-label :key="field.id" :label="field.name" :value="field['value']" :type="field.type == 'datepicker_input' ? 'date' : 'string'" :col-span="getCustomFieldColSpan(field)" />
        </template>
	</div>
</template>

<script>
	export default {
		props: {
			fields: {
				type: Array,
                default: () => []
			},
            customValues: {
                type: Array,
                default: () => []
            }
		},
		data() {
			return {
                customFields: []
			}
		},
		methods: {
            getCustomFieldColSpan(field) {
                if (field.width === 'half') {
                    return 2;
                } else if (field.width === 'full') {
                    return 4;
                } else if (field.width === 'one_third') {
                    return 2;
                } else {
                    return 1;
                }
            },
            updateCustomFields() {
                if (!this.fields || !this.fields.length) {
                    this.customFields = [];
                    return;
                }
                this.customFields = this.fields.map(field => {
                    let customValue = this.customValues ? this.customValues.find(o => o.id == field.id) : undefined;
                    let value = field.type == 'checkbox_input' ? [] : null;
                    if (customValue !== undefined) {
                        value = customValue.value;
                    }
                    return { ...field, value: value };
                });
            }
		},
        mounted() {
            this.updateCustomFields();
        },
        watch: {
            fields: {
                deep: true,
                handler() {
                    this.updateCustomFields();
                }
            },
            customValues: {
                deep: true,
                handler() {
                    this.updateCustomFields();
                }
            }
        }
	}
</script>
